<div id="two-faces-logo-container" 
     [@flipState]='flipState' 
     [ngStyle]="{
          'height': height, 
          'width': width,
          'cursor': clickable ?'pointer' : null}"
     (click)="onClick()">
     <div class="front-face">
          <div class="front-image" 
               [ngStyle]="{'background-image': 'url(' + frontImage + ')',
                          'background-color': bgColor}">
          </div>
     </div>
     <div *ngIf="backImage" class="back-face" [ngStyle]="getBackfaceLogoStyle()">
          <div class="back-image" 
               [ngStyle]="{'background-image': 'url(' + backImage + ')',
                           'background-color': bgColor}">
          </div>
     </div>
</div>